module.exports = __webpack_public_path__ + "img/gravar_default.cf145560.jpg";